import React from 'react';
import { PsListTable } from '../../components/list-table/PsListTable';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import DocumentState from '../../components/DocumentState';
import { PsMoreMenu } from '../../components/more-menu/PsMoreMenu';
import PropTypes from 'prop-types';
import TableCheckbox from '../../components/TableCheckbox';
import { PsCompanyManagement } from '../../model/PsCompanyManagement';
import { PsDocumentRouteGenerator } from '../PsDocumentRouteGenerator';

export class DocumentsTable extends React.Component {

    _documentRouteGenerator = new PsDocumentRouteGenerator();

    render() {
        const {
            data,
            error,
            loading,
            checkItem,
            isChecked,
            checkPage,
            uncheckPage,
            isPageChecked,
            companyManagement,
            areChecksDisplayed,
            hideOutsourceColumn,
        } = this.props;

        const isMyContractors = companyManagement === PsCompanyManagement.MY_CONTRACTORS;

        return (
            <PsListTable
                data={data}
                error={error}
                loading={loading}
                headings={(
                    <tr>
                        {
                            areChecksDisplayed ? (
                                <th>
                                    <TableCheckbox
                                        checked={isPageChecked}
                                        onChange={isPageChecked ? uncheckPage : checkPage}
                                    />
                                </th>
                            ) : null
                        }
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        {
                            hideOutsourceColumn ? null : (
                                <th>{I18nUtils.tr(isMyContractors ? 'TR_CONTRATISTA' : 'TR_SUBCONTRATA')}</th>
                            )
                        }
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_FECHA')}</th>
                        <th>{I18nUtils.tr('TR_CADUCIDAD')}</th>
                        <th/>
                    </tr>
                )}
            >
                {
                    data.map((document) => {
                        const checked = isChecked(document);
                        const route = this._documentRouteGenerator.generateRoute(document, isMyContractors);
                        const onChange = () => checkItem(document);
                        const options = [
                            {
                                label: I18nUtils.tr('TR_VER_FICHA'),
                                route,
                            },
                        ];

                        return (
                            <tr key={document.id()}>
                                {
                                    areChecksDisplayed ? (
                                        <td>
                                            <TableCheckbox
                                                checked={checked}
                                                onChange={onChange}
                                            />
                                        </td>
                                    ) : null
                                }
                                <td><DocumentState state={document.stateData()}/></td>
                                {
                                    hideOutsourceColumn ? null : (
                                        <td>{isMyContractors ? document.contractor() : document.outsource()}</td>
                                    )
                                }
                                <td>{document.name()}</td>
                                <td>{document.startDate()}</td>
                                <td>{document.endDate()}</td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }
}

DocumentsTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
    checkItem: PropTypes.func,
    isChecked: PropTypes.func,
    checkPage: PropTypes.func,
    uncheckPage: PropTypes.func,
    isPageChecked: PropTypes.bool,
    companyManagement: PropTypes.string.isRequired,
    areChecksDisplayed: PropTypes.bool,
    hideOutsourceColumn: PropTypes.bool,
};

DocumentsTable.defaultProps = {
    data: [],
    error: '',
    checkedAll: false,
    areChecksDisplayed: false,
    hideOutsourceColumn: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/document/list/DocumentsTable.jsx